import {
  CopyOutlined,
} from '@ant-design/icons'
import 'animate.css'
import { Checkbox, Modal } from 'antd'
import { lazy, Suspense, useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import BG from '../assets/bg.jpg'
import fastlink2 from '../assets/fastlink2.mp4'
import present from '../assets/present.mp4'
import { Button } from '../components/Button'
import { IssueLoader } from '../components/IssueLoader'
import { useHttp } from '../hooks/http.hook'
import { useMessage } from '../hooks/message.hook.js'
import { ESIMOrder } from '../components/ESIMOrder'
import { DTUOrder } from '../components/DTUOrder'
import { TelegramGift } from '../components/TelegramGift'
import { ShopFollow } from '../components/ShopFollow'
import { ProductInstruction } from '../components/ProductInstruction'
import { OrderLayout } from '../components/OrderLayout'
import { WbRandomInstruction, isWbRandomOrder } from '../components/WbRandomInstruction'
import { isWbCodeOrder, wbCodeInstruction } from '../components/WbCodeInstruction'
import { ElectricProductImage, hasRandomGameCode } from '../components/ElectricProductImage'

import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'



import login1 from '../assets/1.png'
import login2 from '../assets/2.png'


const LootBox = lazy(() =>
  import('../components/LootBox').then((module) => ({ default: module.LootBox })),
)

const LazyLootBox = (props) => (
  <Suspense fallback={<IssueLoader className='z-50' />}>
    <LootBox {...props} />
  </Suspense>
)

export const Main = () => {
  const [orders, setOrders] = useState(null)
  const [claimedRandomCode, setClaimedRandomCode] = useState(null)
  const message = useMessage('dark')

  const { request, error, clearError } = useHttp()
  const [params] = useSearchParams()
  const orderCode = params.get('order')
  const [confirmation, setConfirmation] = useState(false)
  const [waiting, setWaiting] = useState(false)
  const [steamSubmitting, setSteamSubmitting] = useState(false)
  const [steamPoll, setSteamPoll] = useState(false)
  const steamNotices = useRef(new Set())


  useEffect(() => {
    // console.log(error)
    clearError()
  }, [error, clearError])
  const [msgFromServer, setMsgFromServer] = useState(null)
  const [offerType, setOfferType] = useState('code')

  const [form, setForm] = useState({
    code: '',
    login: '',
    link: '',
    gameRoute: null,
  })









  useEffect(() => {
    document.title = 'PAY2PLAY REDEEM'
    const favicon = document.getElementById('favicon')
    favicon.href = '/favicon.svg?v=pay2play-20261019'
  }, [])


  // console.log("----", params.get('order'))

  useEffect(() => {
    // console.log('MOUNT')
    ; (async () => {
      try {
        // console.log('params', params.get('order'))
        const data = await request('/api/order/checkOrder', 'POST', {
          uniquecode: orderCode,
        })


        // console.log(data)
        setMsgFromServer(data.message)
        setOrders(data.purchase)
        setOfferType(data.type)
     //   console.log('offerType - ', data.type)
     //   console.log('orders - ', data)
      } catch (e) {
        console.log(e)
      }
    })()
  }, [orderCode, request])







//   useEffect(() => {
//     const myEmojis = ["🚀", "🔥", "🎮", "💎", "⚡", "🌸",
//       "🎮", // джойстик
//       // "🕹️", // аркадный стик
//       "👾", // пиксельный монстр
//       "💻", // ПК-гейминг
//       // "🖥️", // монитор
//       // "⌨️", // клавиатура
//       // "🖱️", // мышь
//       "🎧", // гарнитура
//       "💎", // кристалл
//       // "⚔️", // меч
//       // "🛡️", // щит
//       "🏹", // лук
//       "🔫", // оружие
//       "🚀", // космос
//       "🔥", // экшен
//       // "⭐", // уровень
//       "🏆", // трофей
//       "🎲", // настолка
//       "🃏", // карты
//     ]

//     function urlAnimate() {
//       const index = Math.floor(Date.now() / 200) % myEmojis.length
//       window.location.hash = myEmojis[index] // меняем hash
//       setTimeout(urlAnimate, 70)
//     }

//     urlAnimate()

//     return () => {
//       window.location.hash = "" // очистить при размонтировании
//     }
//   }, [])













  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text)
      message('Код скопирован в буфер обмена!')
    } catch {
      message('Не удалось скопировать код. Выделите его вручную.')
    }
  }

  const starSVG = () => {
    return (
      <svg
        width='24px'
        height='24px'
        viewBox='-0.5 0 25 25'
        fill='#fff'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M12.71 3.45001L15.17 7.94C15.2272 8.04557 15.307 8.1371 15.4039 8.20801C15.5007 8.27892 15.6121 8.3274 15.73 8.34998L20.73 9.29999C20.8726 9.327 21.0053 9.39183 21.1142 9.48767C21.2232 9.58352 21.3044 9.70688 21.3494 9.84485C21.3943 9.98282 21.4014 10.1303 21.3698 10.272C21.3383 10.4136 21.2693 10.5442 21.17 10.65L17.66 14.38C17.5784 14.4676 17.5172 14.5723 17.4809 14.6864C17.4446 14.8005 17.4341 14.9213 17.45 15.04L18.09 20.12C18.1098 20.2633 18.0903 20.4094 18.0337 20.5425C17.9771 20.6757 17.8854 20.791 17.7684 20.8762C17.6514 20.9613 17.5135 21.0132 17.3694 21.0262C17.2253 21.0392 17.0804 21.0129 16.95 20.95L12.32 18.77C12.2114 18.7155 12.0915 18.6871 11.97 18.6871C11.8485 18.6871 11.7286 18.7155 11.62 18.77L6.99 20.95C6.85904 21.0119 6.71392 21.0375 6.56971 21.0242C6.4255 21.0109 6.28751 20.9591 6.17008 20.8744C6.05265 20.7896 5.96006 20.6749 5.90201 20.5422C5.84396 20.4096 5.82256 20.2638 5.84 20.12L6.49 15.04C6.50596 14.9213 6.49542 14.8005 6.45911 14.6864C6.4228 14.5723 6.36162 14.4676 6.28 14.38L2.76999 10.65C2.67072 10.5442 2.60172 10.4136 2.57017 10.272C2.53861 10.1303 2.54568 9.98282 2.59064 9.84485C2.63561 9.70688 2.71683 9.58352 2.82578 9.48767C2.93473 9.39183 3.06742 9.327 3.21 9.29999L8.21 8.34998C8.32789 8.3274 8.43929 8.27892 8.53614 8.20801C8.63299 8.1371 8.71286 8.04557 8.76999 7.94L11.28 3.45001C11.349 3.32033 11.4521 3.21187 11.578 3.13623C11.704 3.0606 11.8481 3.02063 11.995 3.02063C12.1419 3.02063 12.2861 3.0606 12.412 3.13623C12.538 3.21187 12.641 3.32033 12.71 3.45001V3.45001Z'
          stroke='#fff'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    )
  }

  const [modal2Open, setModal2Open] = useState(false)
  const [modal6Open, setModal6Open] = useState(false)
  const [modal3Open, setModal3Open] = useState(false)
  const [modal4Open, setModal4Open] = useState(false)
  const [modal5Open, setModal5Open] = useState(false)
  const [modal7Open, setModal7Open] = useState(false)

  useEffect(() => {
    const steam = orders?.steam
    if (offerType !== 'topUp' || !steam?.state || steam.state === 'new' || !steam.message) return
    const key = `${orderCode}:${steam.attemptId || 'legacy'}:${steam.state}:${steam.accepted === true}`
    if (steamNotices.current.has(key)) return
    steamNotices.current.add(key)
    message(steam.message)
  }, [offerType, orderCode, orders?.steam, message])

  // Poll the local persisted state; the server worker owns supplier requests.
  useEffect(() => {
    if (offerType !== 'topUp' || (!steamPoll && !['preparing', 'pending'].includes(orders?.steam?.state))) return
    let stopped = false, timer
    const poll = async () => {
      try {
        const data = await request('/api/order/checkOrder', 'POST', { uniquecode: orderCode })
        if (stopped) return
        if (data.type === 'topUp' && data.purchase?.steam) {
          setOrders(data.purchase)
          if (!['preparing', 'pending'].includes(data.purchase.steam.state)) {
            setSteamPoll(false)
            return
          }
        }
      } catch (_) { /* Keep polling after a lost browser response. */ }
      if (!stopped) timer = setTimeout(poll, 5000)
    }
    timer = setTimeout(poll, 2000)
    return () => { stopped = true; clearTimeout(timer) }
  }, [offerType, orderCode, orders?.steam?.state, steamPoll, request])

  const extingOrderHandler = async () => {
    if (steamSubmitting || !orders?.steam?.canSubmit) return
    if (!confirmation) return message('Подтвердите логин Steam')
    if (!form.login) return message('Введите логин Steam')
    setSteamSubmitting(true)
    setSteamPoll(true)
    try {
      const data = await request('/api/order/extingOrder', 'POST', { login: form.login, code: orderCode })
      if (data.steam?.state === 'paused') {
        setSteamPoll(false)
        message(data.steam.message)
      } else if (data.steam) {
        setOrders(previous => ({ ...previous, steam: data.steam, completed: data.steam.completed }))
      } else message(data.message)
    } catch (error) {
      if (error.status === 503 && error.code === 'STEAM_TOPUP_PAUSED') {
        // This explicit response is returned before creating any paid attempt.
        // Network failures remain ambiguous and still require reconciliation.
        setSteamPoll(false)
        message(error.message)
      } else {
        message('Не удалось получить ответ. Проверяем состояние заказа; не отправляйте другую покупку.')
      }
    } finally {
      setSteamSubmitting(false)
    }
  }

  const extingGiftOrderHandler = async () => {


    if (!form.link.includes('https://s.team/p/')) {
      message('Ссылка должна иметь формат: https://s.team/p/xxxx-xxxx/XXXXXXX 😰')
      return
    }



    if (confirmation && form.link) {

      setWaiting(true)
      try {
        const extingOrder = await request('/api/order/extingGift', 'POST', { ...form, code: orderCode })

        message(extingOrder?.message)
        message(extingOrder?.error_message)
        if (extingOrder.status) {
          setOrders(extingOrder.purchase)
        }
      } catch (error) {
        message(error.message)
      } finally {
        setWaiting(false)
      }

    } else if (!confirmation) {
      message('Вы не подтвердили ссылку на дружбу (быстрое приглашение)! 😰')
    } else if (!form.link) {
      message('Введите ссылку на дружбу (быстрое приглашение)! 😰')
    }
  }





  const handleCancel = () => {
    setModal2Open(false)
    setModal3Open(false)
    setModal4Open(false)
    setModal5Open(false)
    setModal6Open(false)
    setModal7Open(false)
  }




  const msgFromServerContent = (msg) => {
    switch (msg) {
      case 'wrong unique code':
        return (
          <>
            <div className='flex flex-col w-full h-screen scrollbar-hide items-center justify-center'>
              <div className='text-[#fff] font-medium text-[22px] sm:text-[24px] md:text-[34px] lg:text-[44px] text-center'>
                Нет такой покупки!
              </div>
            </div>
          </>
        )
      case 'purchase not issued':
        return (
          <>
            <div className='flex flex-col w-full h-screen scrollbar-hide items-center justify-center gap-[20px]'>
              <div className='text-[#fff] font-medium text-[22px] sm:text-[24px] md:text-[34px] lg:text-[44px] text-center flex flex-col'>
                Терпение лопнуло, код не выдан, пожалуйста напишите в чат по заказу на Яндекс Маркет!
              </div>
            </div>
          </>
        )
      default:
        return (
          <>
            <div className='flex flex-col w-full h-screen scrollbar-hide items-center justify-center'>
              {msg ? (
                <div className='text-[#fff] font-medium text-[22px] sm:text-[24px] md:text-[34px] lg:text-[44px] text-center px-4'>
                  {msg}
                </div>
              ) : (
                <IssueLoader className='z-50' />
              )}
            </div >
          </>
        )
    }

  }



  const offerTypeContent = (type) => {
    if (type === 'DTU') return <DTUOrder orders={orders} code={orderCode} onCompleted={setOrders} messageContent={msgFromServerContent(msgFromServer)} />
    if (type === 'eSIM') return <ESIMOrder orders={orders} messageContent={msgFromServerContent(msgFromServer)} />
    if (!orders) return msgFromServerContent(msgFromServer)

    const copyCode = (value, label) => <div className='order-code'>
      <code>{value}</code>
      <button type='button' className='order-copy' aria-label={label} onClick={() => copyToClipboard(value)}><CopyOutlined /></button>
    </div>

    switch (type) {
      case 'random':
      case 'random_tg_gift': {
        const wbOrder = isWbRandomOrder(orders, type)
        const requiresReview = orders.phase === 'manual_review'
        const received = !requiresReview && (hasRandomGameCode(orders) || claimedRandomCode === orderCode)
        return <OrderLayout orders={orders} kind={type} complete={received}
          dateLabel={hasRandomGameCode(orders) ? 'Получено' : 'Дата заказа'}
          status={requiresReview ? 'Требует проверки' : received ? 'Ключ получен' : 'Готов к получению'}
          extra={{ label: 'Активация', value: 'Steam' }}
          image={<ElectricProductImage src={orders.image} active={!received && !requiresReview} type='random' />}
          after={<>
            {!wbOrder && <TelegramGift received={received} />}
            {wbOrder ? <WbRandomInstruction /> : type === 'random_tg_gift' ? <ProductInstruction
                        key={orderCode}
                        title='Как получить и активировать игру'
                        hint='Получение случайной игры и активация ключа в Steam — в инструкции.'
                        html={'<h1>🎁 Инструкция по получению ключа!</h1><p>Для получения случайной игры Steam нажмите кнопку «Получить игру». После небольшой задержки вы увидите название случайной игры, а под названием будет показана ссылка на SteamDB где вы сможете узнать подробную информацию о ней.</p><p>Если полученная игра вам подходит, нажмите кнопку «Получить игру» — после этого вы получите ключ активации для Steam.</p><p>Если игра вам не понравилась, вы можете нажать кнопку «ЗАМЕНА», чтобы получить другую случайную игру вместо первоначальной. После замены игра может оказаться как дороже, так и дешевле предыдущей, однако в любом случае её стоимость будет выше суммы, которую вы заплатили.</p><p>Возможность замены игры даётся только один раз. После замены название и ключ новой игры появятся сразу — повторно нажимать «Получить игру» не нужно.</p><p>При сравнении стоимости обращайте внимание на цену игры в Steam без учёта скидок.</p><h1>💻 Инструкция для активации через приложение Steam</h1><ol><li>Откройте приложение Steam на вашем компьютере. Если программа не установлена — скачайте её с официального сайта <a href="https://store.steampowered.com" target="_blank">https://store.steampowered.com</a> и выполните установку.</li><li>Войдите в свой аккаунт Steam.</li><li>В верхнем меню выберите пункт «Игры».</li><li>Нажмите «Активировать в Steam…».</li><li>Введите полученный ключ в специальное поле и подтвердите активацию.</li><li>После успешной активации игра появится в вашей библиотеке Steam.</li></ol><(◕‿◕｡)۶💜Приятного рандома!💜٩(◕‿◕)۶</h3>'}
                      /> : <ProductInstruction key={orderCode} title='Как получить и активировать игру' hint='Получение случайной игры и активация ключа в Steam — в инструкции.' html={orders.issue_instruction} />}
            {received && !wbOrder && <ShopFollow showReview={type !== 'random_tg_gift'} />}
          </>}>
          {requiresReview ? <p role='alert' className='order-note'>Предыдущая выдача была прервана и требует проверки. Напишите продавцу в чате заказа. Повторная выдача не запускается.</p> : <LazyLootBox key={orderCode} uniquecode={orderCode} orders={orders} compact showPromotions={false} showReview={!wbOrder && type !== 'random_tg_gift'} onClaimed={() => setClaimedRandomCode(orderCode)} />}
        </OrderLayout>
      }
      case 'topUp': {
        const wbOrder = /^WB-\d+$/.test(String(orders.orderNumber || ''))
        if (orders.steam?.state === 'disabled') return msgFromServerContent(orders.steam.message)
        const accepted = orders.steam?.state === 'pending' && orders.steam?.accepted === true && !orders.steam?.recipientUnverified
        const successfulView = Boolean(orders.completed || accepted)
        const status = orders.steam?.state === 'used' ? 'Ссылка использована' : orders.completed ? 'Выполнен' : accepted ? 'Успешно отправлено' : ({ preparing: 'Проверяется', pending: 'Обрабатывается', cancelled: 'Отменён', timed_out: 'Результат не подтверждён', review: 'Нужна проверка', rejected: 'Проверка не пройдена' }[orders.steam?.state] || 'Не использован')
        return <OrderLayout orders={orders} kind='topUp' status={status} complete={successfulView}
          dateLabel='Дата и время получения:' dateValue={orders.steam?.recipientUnverified ? 'Не подтверждена' : orders.completed ? undefined : 'Отсутствует'}
          facts={[{ label: 'Логин:', value: orders.steam?.recipientUnverified ? 'Не подтверждён' : orders.steam?.attemptLogin || orders.login || 'Отсутствует' }]}
          image={<ElectricProductImage src={orders.image} active={orders.steam?.canSubmit === true && !orders.completed && !steamSubmitting} type='topup' />}
          after={<>
            {!wbOrder && <TelegramGift received={Boolean(orders.completed)} ready={accepted} purchaseType='topup' />}
            {!successfulView && <ProductInstruction key={orderCode} title='Как пополнить Steam' hint='Откройте инструкцию перед пополнением кошелька Steam.' html={orders.issue_instruction} />}
            {orders.completed && <ShopFollow />}
            <section className='order-help' aria-label='Помощь с пополнением Steam'>
              <h2>Часто задаваемые вопросы</h2>
              {!successfulView ? <>
                <button type='button' className='order-faq-button' onClick={() => setModal2Open(true)}>Где найти мой логин в Steam?<span aria-hidden='true'>›</span></button>
                <button type='button' className='order-faq-button' onClick={() => setModal3Open(true)}>Описание сервиса<span aria-hidden='true'>›</span></button>
                <button type='button' className='order-faq-button' onClick={() => setModal5Open(true)}>Для жителей ДНР, ЛНР и Крыма<span aria-hidden='true'>›</span></button>
              </> : <button type='button' className='order-faq-button' onClick={() => setModal4Open(true)}>Пополнение не поступило на мой аккаунт?<span aria-hidden='true'>›</span></button>}
            </section>
          </>}>
          {orders.completed && orders.steam?.state !== 'used' && !orders.steam?.recipientUnverified && <h2 className='order-result-title'>Пополнение выполнено</h2>}
          {accepted && <h2 className='order-result-title'>Пополнение успешно отправлено</h2>}
          <div role='status' className='order-note'>{orders.steam?.message}{!accepted && ['preparing', 'pending'].includes(orders.steam?.state) && <div className='steam-progress'><Spin /></div>}</div>
          {orders.steam?.canSubmit && <div className='order-form'>
            <div className='order-input-help'>
              <label htmlFor='steam-login'>Логин Steam</label>
              <input id='steam-login' value={form.login} onChange={(e) => setForm({ ...form, login: e.target.value.trim() })} placeholder='Укажите ваш логин в Steam:' />
              <button type='button' className='order-help-link' onClick={() => setModal2Open(true)}>Как узнать логин?</button>
            </div>
            <Checkbox onChange={(e) => setConfirmation(e.target.checked)} checked={confirmation} className='text-white'>Подтверждаю, что мой логин в Steam указан верно, и я ознакомился с описанием товара.</Checkbox>
            <Button type='primary' color='purple' size='md' onClick={extingOrderHandler} loading={steamSubmitting} disabled={steamSubmitting || steamPoll}>ПОПОЛНИТЬ</Button>
          </div>}
        </OrderLayout>
      }
      case 'account':
        return <OrderLayout orders={orders} kind='account' extra={{ label: 'Выдача', value: 'Логин и пароль' }} after={<>
          <ProductInstruction key={orderCode} title='Как использовать аккаунт' hint='Вход в аккаунт и рекомендации по использованию.' html={orders.issue_instruction} />
          <ShopFollow />
        </>}>
          <h2 className='order-result-title'>Учетные данные</h2>
          <div className='order-account-values'>{orders.login?.split('::')?.map((item, index) => {
            const label = ['Steam Login', 'Steam Password', 'Email', 'Email Password'][index] || `Field ${index + 1}`
            return <div key={index}><div className='order-value-label'>{label}</div>{copyCode(item, `Скопировать ${label}`)}</div>
          })}</div>
        </OrderLayout>
      case 'gift':
        return <OrderLayout orders={orders} kind='gift' complete={Boolean(orders.login)} status={orders.login ? 'Отправлен' : 'Не отправлен'}
          dateLabel='Дата и время отправки:' dateValue={orders.login ? undefined : 'Отсутствует'} extra={{ label: 'Способ', value: 'Подарок в Steam' }}
          after={<>
            {!orders.login && <ProductInstruction title='Как получить подарок в Steam' hint='Откройте инструкцию перед отправкой приглашения.'>
              <p>Спасибо, что выбрали магазин 💜PAY2PLAY💜! (◕‿◕)</p>
              <ol>
                <li>Вставьте <button type='button' className='order-help-link' onClick={() => setModal6Open(true)}>ссылку на дружбу</button> (быстрое приглашение) в поле ввода.</li>
                <li>Подтвердите актуальность указанной ссылки.</li>
                <li>Нажмите «ПОЛУЧИТЬ».</li>
                <li><button type='button' className='order-help-link' onClick={() => setModal7Open(true)}>Примите подарок</button> (игру) в Steam.</li>
              </ol>
            </ProductInstruction>}
            <section className='order-help' aria-label='Помощь с подарком Steam'>
              <h2>{orders.login ? 'Подарок уже у Вас, скорее примите его 💜!' : 'Часто задаваемые вопросы'}</h2>
              {!orders.login ? <Button onClick={() => setModal6Open(true)}>Как получить ссылку на дружбу (быстрое приглашение)?</Button>
                : <Button onClick={() => setModal7Open(true)}>Где найти и как принять подарок (игру)?</Button>}
            </section>
            {orders.login && <ShopFollow />}
          </>}>
          {!orders.login ? <div className='order-form'>
            <div className='order-input-help'>
              <label htmlFor='steam-invitation'>Ссылка-приглашение Steam</label>
              <input id='steam-invitation' value={form.link} onChange={(e) => setForm({ ...form, link: e.target.value.trim() })} placeholder='Укажите вашу ссылку на дружбу:' />
              <button type='button' className='order-help-link' onClick={() => setModal6Open(true)}>Как узнать?</button>
            </div>
            <Checkbox onChange={(e) => setConfirmation(e.target.checked)} checked={confirmation} className='text-white'>Подтверждаю, что ссылка на дружбу (быстрое приглашение) является актуальной.</Checkbox>
            {waiting ? <div><Spin indicator={<LoadingOutlined spin />} size='large' /><div>Отправляем подарок!</div></div>
              : <Button type='primary' color='purple' size='md' onClick={extingGiftOrderHandler}>ПОЛУЧИТЬ</Button>}
          </div> : <h2 className='order-result-title'>Подарок отправлен</h2>}
        </OrderLayout>
      default:
        return <OrderLayout orders={orders} kind='code' extra={{ label: 'Количество', value: orders.codes?.length }} after={<>
          <ProductInstruction key={orderCode} html={isWbCodeOrder(orders, type) ? wbCodeInstruction(orders.issue_instruction) : orders.issue_instruction} />
          {!isWbCodeOrder(orders, type) && <ShopFollow />}
        </>}>
          <h2 className='order-result-title'>{orders.codes?.length > 1 ? 'Цифровые ключи' : 'Цифровой ключ'}</h2>
          {orders.codes?.map((item, index) => <div key={item.id || index}>{copyCode(item.code, `Скопировать код ${index + 1}`)}</div>)}
        </OrderLayout>
    }
  }
  return (
    <>
      <>
        <div
          className='relative w-full bg-cover bg-black  bg-no-repeat bg-fixed'
          style={{ backgroundImage: `url(${BG})` }}
        >
          {offerTypeContent(offerType)}
        </div>

        <div className='fixed top-0 w-full text-[#fff] flex flex-row pl-[30px] items-start h-[25px]  bg-slate-950/[.2] backdrop-blur-md'>
          <div></div>
        </div>
        <div className='fixed bottom-0 gap-[10px] w-full text-[#fff] flex flex-row justify-center items-center px-[10px] text-[10px] md:text-[16px] py-[5px] bg-slate-950/[.2] backdrop-blur-md'>
          <div> PAY2PLAY</div>
        </div>
      </>

      <Modal
        title='Где найти мой логин в Steam?'
        centered
        width={1000}
        open={modal2Open}
        onOk={() => setModal2Open(false)}
        onCancel={() => setModal2Open(false)}
        className='custom-modal'
        footer={[
          <Button
            key='back'
            type='primary'
            color='purple'
            size='md'
            className=' py-3 mt-5 px-[55px]'
            onClick={handleCancel}
          // disabled={loading}
          >
            <div style={{ fontFamily: '"Trebuchet MS", "Segoe UI", Arial, sans-serif' }}>Понятно!</div>
          </Button>,
        ]}
      >
        <div
          className='flex flex-col items-center px-[20px] mt-[10px] text-[#fff] gap-[10px]'
          style={{ fontFamily: '"Trebuchet MS", "Segoe UI", Arial, sans-serif' }}
        >
          <div>
            Нажмите в правом верхнем меню на ваш профиль. Откроется выпадающий
            список. Ваш логин указан во второй строчке. Так же вы его вводите
            при входе в Steam.
          </div>
          <div className='flex flex-row gap-[10px]'>
            <img src={login1} className='w-1/2 mb-[20px] rounded-xl' />
            <img src={login2} className='w-1/2 mb-[20px] rounded-xl' />
          </div>
        </div>
      </Modal>





      <Modal
        title='Как получить ссылку на дружбу (быстрое приглашение)?'
        centered
        width={1000}
        open={modal6Open}
        onOk={() => setModal6Open(false)}
        onCancel={() => setModal6Open(false)}
        className='custom-modal'
        footer={[
          <Button
            key='back'
            type='primary'
            color='purple'
            size='md'
            className=' py-3 mt-5 px-[55px]'
            onClick={handleCancel}
          // disabled={loading}
          >
            <div style={{ fontFamily: '"Trebuchet MS", "Segoe UI", Arial, sans-serif' }}>Понятно!</div>
          </Button>,
        ]}
      >
        <div
          className='flex flex-col items-center  mt-[10px] text-[#fff] gap-[10px]'
          style={{ fontFamily: '"Trebuchet MS", "Segoe UI", Arial, sans-serif' }}
        >
          {/* <div>
            Нажмите в правом верхнем меню на ваш профиль. Откроется выпадающий
            список. Ваш логин указан во второй строчке. Так же вы его вводите
            при входе в Steam.
          </div> */}
          <div className='flex flex-row gap-[10px]'>
            {/* <img src={login1} className='w-1/2 mb-[20px] rounded-xl' />
            <img src={login2} className='w-1/2 mb-[20px] rounded-xl' /> */}

            {/* <video
              src="src/assets/fastlink2.mp4"
              className='w-full h'
              autoPlay
              muted
              loop
              playsInline
            />

 <video
              src="/assets/fastlink2.mp4"
              className='w-full h'
              autoPlay
              muted
              loop
              playsInline
            /> */}

            <video
              src={fastlink2}
              className='w-full'
              autoPlay
              muted
              loop
              playsInline
            />



          </div>
        </div>
      </Modal>





      <Modal
        title='Где найти и как принять подарок (игру)?'
        centered
        width={1000}
        open={modal7Open}
        onOk={() => setModal7Open(false)}
        onCancel={() => setModal7Open(false)}
        className='custom-modal'
        footer={[
          <Button
            key='back'
            type='primary'
            color='purple'
            size='md'
            className=' py-3 mt-5 px-[55px]'
            onClick={handleCancel}
          // disabled={loading}
          >
            <div style={{ fontFamily: '"Trebuchet MS", "Segoe UI", Arial, sans-serif' }}>Понятно!</div>
          </Button>,
        ]}
      >
        <div
          className='flex flex-col items-center  mt-[10px] text-[#fff] gap-[10px]'
          style={{ fontFamily: '"Trebuchet MS", "Segoe UI", Arial, sans-serif' }}
        >
          {/* <div>
            Нажмите в правом верхнем меню на ваш профиль. Откроется выпадающий
            список. Ваш логин указан во второй строчке. Так же вы его вводите
            при входе в Steam.
          </div> */}
          <div className='flex flex-row gap-[10px]'>
            {/* <img src={login1} className='w-1/2 mb-[20px] rounded-xl' />
            <img src={login2} className='w-1/2 mb-[20px] rounded-xl' /> */}

            {/* <video
              src="src/assets/fastlink2.mp4"
              className='w-full h'
              autoPlay
              muted
              loop
              playsInline
            />

 <video
              src="/assets/fastlink2.mp4"
              className='w-full h'
              autoPlay
              muted
              loop
              playsInline
            /> */}

            <video
              src={present}
              className='w-full'
              autoPlay
              muted
              loop
              playsInline
            />



          </div>
        </div>
      </Modal>





      <Modal
        title="Описание сервиса"
        centered
        width={1000}
        open={modal3Open}
        onOk={() => setModal3Open(false)}
        onCancel={() => setModal3Open(false)}
        className="custom-modal"
        footer={[

          <Button
            key="back"
            type="primary"
            color="purple"
            size="md"
            className=" py-3 mt-5 px-[55px]"
            onClick={handleCancel}
          // disabled={loading}
          >
            <div style={{ fontFamily: '"Trebuchet MS", "Segoe UI", Arial, sans-serif' }}>Понятно!</div>
          </Button>



        ]}
      >
        <div className='flex flex-col px-[20px] mt-[10px] text-[#fff] mb-[10px] gap-3' style={{ fontFamily: '"Trebuchet MS", "Segoe UI", Arial, sans-serif' }}>



          <div className='text-[20px]'>Пополнение Steam баланса по логину вашего аккаунта (без входа).</div>

          <div className='flex flex-col gap-1'>
            <div className='text-[#87CEEB] text-[18px]'>Доступно пополнение для следующий стран:</div>
            <p>Россия, Украина, Азербайджан, Армения, Беларусь, Грузия, Казахстан, Кыргызстан, Молдова, Таджикистан, Туркменистан,
              Узбекистан. * ДНР/ЛНР/Крым (прочтите ниже)</p>
            <p>При пополнение аккаунта Steam переведет вам необходимую сумму в долларах США (родная валюта), с последующей
              конвертацией на аккаунте в валюту вашего кошелька. Курсы валют Steam можно посмотреть на сайте
              https://steam-currency.ru. Обращаем ваше внимание, курс обновляется один раз в сутки.</p>
          </div>

          <div className='flex flex-col gap-1'>
            <div className='text-[#87CEEB] text-[18px]'>Для пополнения аккаунтов с ip адресами ДНР, ЛНР, Крыма, необходимо выполнить следующие условия:</div>

            <ol>
              <li>1. - Выйдите из вашего аккаунта со всех устройств на 1 час. Это касается и мобильного приложения Steam.</li>
              <li>2. - Через 1 час активируйте ваш подарочный код.</li>
              <li>3. - Заходите снова в ваш аккаунт и наслаждайтесь играми!</li>
            </ol>
          </div>

          <div className='flex flex-col gap-1'>
            <div className='text-[#87CEEB] text-[18px]'>Пополнение новых аккаунтов:</div>
            Если вы пополняете аккаунт на котором до этого не было финансовых операций, его регион может измениться на
            Казахстан, Узбекистан или другой похожий регион, а валюта на CIS $ (или другие).
            Чтобы этого избежать и сохранить ваш регион у нового аккаунта следуйте этой инструкции:


            <ol>
              <li>1. - Заходите в Steam под ip страны Вашего аккаунта.</li>
              <li>2. - Переходим в раздел пополнения кошелька подарочными картами Steam:
                https://store.steampowered.com/account/redeemwalletcode</li>
              <li>3. - Вводите любой неправильный код пополнения кошелька, например: B9KYK-3U3L8-BKHWA.</li>
              <li>4. - Получаете закрепленную валюту на кошельке. Все просто! Теперь при пополнение регион не слетит.</li>
            </ol>
          </div>


        </div>
      </Modal>

      <Modal
        title="Почему пополнение не поступило на мой аккаунт мгновенно?"
        centered
        width={1000}
        open={modal4Open}
        onOk={() => setModal4Open(false)}
        onCancel={() => setModal4Open(false)}
        className="custom-modal"
        footer={[

          <Button
            key="back"
            type="primary"
            color="purple"
            size="md"
            className=" py-3 mt-5 px-[55px]"
            onClick={handleCancel}
          // disabled={loading}
          >
            <div style={{ fontFamily: '"Trebuchet MS", "Segoe UI", Arial, sans-serif' }}>Понятно!</div>
          </Button>



        ]}
      >

        <div className=' px-[20px] mt-[10px] text-[#fff] mb-[10px]' style={{ fontFamily: '"Trebuchet MS", "Segoe UI", Arial, sans-serif' }}>
          В некоторых редких случаях пополнение может задержаться на несколько минут. Но обычно этого не происходит.
          Если пополнения нет долгое время, просим вас связаться с продавцом в чате вашего товара в "Яндекс Маркет".
        </div>

      </Modal>

      <Modal
        title="Для жителей ДНР, ЛНР, Крым!"
        centered
        width={1000}
        open={modal5Open}
        onOk={() => setModal5Open(false)}
        onCancel={() => setModal5Open(false)}
        className="custom-modal"
        footer={[

          <Button
            key="back"
            type="primary"
            color="purple"
            size="md"
            className=" py-3 mt-5 px-[55px]"
            onClick={handleCancel}
          // disabled={loading}
          >
            <div style={{ fontFamily: '"Trebuchet MS", "Segoe UI", Arial, sans-serif' }}>Понятно!</div>
          </Button>



        ]}
      >
        <div className='flex flex-col px-[20px] mt-[10px] text-[#fff] mb-[10px]' style={{ fontFamily: '"Trebuchet MS", "Segoe UI", Arial, sans-serif' }}>
          <div className='text-[#fd3b85] text-[22px] mt-3 mb-1'>Важно!</div>
          <div className='flex flex-col gap-1'>
            <div className='text-[#87CEEB] text-[18px]'>Для пополнения аккаунтов с ip адресами ДНР, ЛНР, Крыма, необходимо выполнить следующие условия:</div>

            <ol>
              <li>1. - Выйдите из вашего аккаунта со всех устройств на 1 час. Это касается и мобильного приложения Steam.</li>
              <li>2. - Через 1 час активируйте ваш подарочный код.</li>
              <li>3. - Заходите снова в ваш аккаунт и наслаждайтесь играми!</li>
            </ol>
          </div>
        </div>
      </Modal>









    </>
  )
}
